import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { BrandKitProvider } from './contexts/BrandKitContext';
import { NotificationProvider } from './contexts/NotificationContext';
import Layout from './components/layout/Layout';
import Dashboard from './pages/Dashboard';
import ProcessPage from './pages/ProcessPage';
import BrandKitPage from './pages/BrandKitPage';
import PreviewPage from './pages/PreviewPage';
import UploadTesterPage from './pages/UploadTesterPage';
import QuickUploaderPage from './pages/QuickUploaderPage';
import DropboxTesterPage from './pages/DropboxTesterPage';
import BrandKitDebuggerPage from './pages/BrandKitDebuggerPage';
import NCBTesterPage from './pages/NCBTesterPage';
import './index.css';

function App() {
  return (
    <NotificationProvider>
      <BrandKitProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Dashboard />} />
              <Route path="process" element={<ProcessPage />} />
              <Route path="brand-kit" element={<BrandKitPage />} />
              <Route path="preview" element={<PreviewPage />} />
              <Route path="debug/upload-tester" element={<UploadTesterPage />} />
              <Route path="debug/quick-uploader" element={<QuickUploaderPage />} />
              <Route path="debug/dropbox-tester" element={<DropboxTesterPage />} />
              <Route path="debug/brand-kit-debugger" element={<BrandKitDebuggerPage />} />
              <Route path="debug/ncb-tester" element={<NCBTesterPage />} />
            </Route>
          </Routes>
        </Router>
      </BrandKitProvider>
    </NotificationProvider>
  );
}

export default App;